// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1KqUl","inputDescription":"styles_inputDescription__2EJ40"};